export default {
    preloader: false,
    data: [],
    branchoffices_warehouses: [],
    branchoffices: [],
    branchoffice_id: null,
    warehouse_id: null,
    params: {
        branchoffice_id:null,
        branchoffice_warehouse_id: null,
        file: null,
        validated: false,
    }
}



// WEBPACK FOOTER //
// ./src/modules/incorporate_inventory_initial_balance/state.js